/* eslint-disable */
export default {
  title: 'Region',
  NAOnlyMessage:
    'Legen Sie Ihre Vorwahl fest. Diese Information wird für Ortsgespräche verwendet.',
  MultiWithNAMessage:
    'Legen Sie das Land und die Vorwahl Ihrer Region fest. Diese Information wird für Ortsgespräche und die Formatierung der Telefonnummer verwendet.',
  MultiWithoutNAMessage:
    'Wählen Sie das Land aus, in dem Sie sich befinden. Dies wird für Ortsgespräche und die Telefonnummernformatierung verwendet.',
  country: 'Land',
  areaCode: 'Vorwahl',
  areaCodePlaceholder: 'Vorwahl eingeben',
} as const;

// @key: @#@"title"@#@ @source: @#@"Region"@#@
// @key: @#@"NAOnlyMessage"@#@ @source: @#@"Please set your area code. This will be used for local dialing."@#@
// @key: @#@"MultiWithNAMessage"@#@ @source: @#@"Please set the country and area code for your region. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"MultiWithoutNAMessage"@#@ @source: @#@"Please select the country you locate in. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"country"@#@ @source: @#@"Country"@#@
// @key: @#@"areaCode"@#@ @source: @#@"Area Code"@#@
// @key: @#@"areaCodePlaceholder"@#@ @source: @#@"Enter Area Code"@#@
